import { ApiRequestError } from './errors';

export const _404 = (fallback?: any) => (err: ApiRequestError) => {
	if (err.data && err.data.status === 404) {
		return Promise.resolve(fallback || null);
	}
	return Promise.reject(err);
};
